export default class VSLRow {

    constructor(id, type) {
        this.id = id;
        this.type = type;
    }
}